import { RootStore, PagedList, DemandPosition } from ".";
import { observable, action, runInAction } from "mobx";
import { formatDateJson } from "../common/Formatting";
import { fetchWrapper } from "../common/Fetch";
import { SuccessableResult } from "../common/BaseClasses";
import { NotificationLevel } from "./NotificationStore";

export interface Acceptance {
    id: number;
    dateCreate: Date;
    deliveryTimeString: string;
    userName: string;
    positionsCount: number;
    summ: number;
    comment: string;
}

export interface WaitingDemandPosition extends DemandPosition {
    acceptedCount: number;
}

export interface NewAcceptancePosition {
    positionId: number;
    acceptCount: number;
}

export class AcceptancesStore {

    _rootStore: RootStore;

    @observable waitingDemands: WaitingDemandPosition[] = [];
    @observable acceptances: Acceptance[] = [];
    @observable currentPage = 1;
    @observable totalOrdersCount = 1;
    @observable newRejectionsCount = 0;


    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadAcceptances(page = 1, dateFrom?: Date, dateTo?: Date) {
        this.acceptances = [];
        const dateFromStr = dateFrom == undefined ? '' : formatDateJson(dateFrom);
        const dateToStr = dateTo == undefined ? '' : formatDateJson(dateTo);

        fetchWrapper(`api/Acceptances/list/${page}?dateFrom=${dateFromStr}&dateTo=${dateToStr}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<Acceptance>>)
            .then(result => {
                runInAction("fetch complete loadAcceptances", () => {
                    this.currentPage = page;
                    this.totalOrdersCount = result.totalItemCount;
                    this.acceptances = result.items;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    loadWaitingAcceptances() {
        this.waitingDemands = [];


        fetchWrapper(`api/Acceptances/waitingdemands`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<WaitingDemandPosition[]>)
            .then(result => {
                runInAction("fetch complete loadAcceptances", () => {
                    this.waitingDemands = result;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    createAcceptance(formUniqueKey: number, positions: NewAcceptancePosition[], comment: string, callback: () => void) {

        const data = {
            positions,
            comment,
            formUniqueKey
        };
        fetchWrapper('api/acceptances/SaveAcceptance', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete loadDeliveryPoints", () => {
                    if (result.isSuccess) {
                        if (result.errorMessage != undefined) {
                            this._rootStore.notificationStore.addNotification(result.errorMessage, NotificationLevel.warning, -1);
                        }
                        else {
                            this._rootStore.notificationStore.addNotification("Приемка успешно создана!", NotificationLevel.success);
                            callback();
                        }
                    }
                    else {
                        this._rootStore.notificationStore.addNotification("Ошибка при сохранении! " + result.errorMessage, NotificationLevel.error);
                    }
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

}